import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=4b04692a&scoped=true&"
import script from "./AlertModal.vue?vue&type=script&lang=js&"
export * from "./AlertModal.vue?vue&type=script&lang=js&"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=4b04692a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04692a",
  null
  
)

export default component.exports